module.exports = __webpack_public_path__ + "img/banner-3.5c74f2c0.jpg";